import { ReactNode, useState } from "react";
import { Flex, Typography, Button, Tooltip } from "antd";
import { CheckOutlined } from "@ant-design/icons";

import { copyText } from "utils";
import { ReactComponent as CopyIcon } from "images/copy.svg";

import copyableTextStyles from "../../ui/CopyableText/copyableText.module.css";
import styles from "./info.module.css";

interface IProps {
  title: string | ReactNode;
  text: string;
  id?: string;
  horizontal?: boolean;
}

export const ItemInfoCopy = (props: IProps) => {
  const { title, text, id, horizontal = false } = props;
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (text) {
      await copyText(text).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1000);
      });
    }
  };

  if (horizontal) {
    return (
      <Flex
        id={id}
        gap="8px"
        justify="space-between"
        align="baseline"
        className={`${styles.horizontalItemBox} full-width`}
      >
        <Typography.Text type="secondary" className={styles.labelCol}>
          {title}
        </Typography.Text>
        <Flex
          flex={1}
          justify="flex-end"
          align="center"
          gap="small"
          className={`text-middle text-align-right ${styles.infoCol}`}
        >
          <Typography.Text className="text-middle">{text}</Typography.Text>
          <Button
            type="link"
            size="middle"
            onClick={handleCopy}
            className={`${copyableTextStyles.copyButton} copyIcon`}
          >
            <Tooltip title={copied ? "Скопировано" : "Копировать"}>
              {copied ? <CheckOutlined className={copyableTextStyles.checkIcon} /> : <CopyIcon className="copyIcon" />}
            </Tooltip>
          </Button>
        </Flex>
      </Flex>
    );
  }

  return (
    <Flex id={id} gap="small" justify="space-between" align="start" className="full-width padding-bottom-md">
      <Flex vertical gap="small">
        <Typography.Text type="secondary">{title}</Typography.Text>
        <Typography.Text className="text-middle">{text}</Typography.Text>
      </Flex>
      <Button type="link" size="middle" onClick={handleCopy} className={`${copyableTextStyles.copyButton} copyIcon`}>
        <Tooltip title={copied ? "Скопировано" : "Копировать"}>
          {copied ? <CheckOutlined className={copyableTextStyles.checkIcon} /> : <CopyIcon className="copyIcon" />}
        </Tooltip>
      </Button>
    </Flex>
  );
};
